export enum transactionStatus {
  successful = "successful",
  processing = "processing",
  abandoned = "abandoned",
  partial = "partial",
  refunded = "refunded",
  failed = "failed",
  pending = "pending",
}
